import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import {NgbDateStruct, NgbTimepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import { GridOptions } from "ag-grid/main";
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

import {Task, WpPerson, Appointment, AgGridUtility, DOUBLE_ROW_HEADER, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, TaskHistory } from '../shared';
import { DateUtility, TimeUtility, CommonUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import {ProviderOffice} from "../shared/model/ProviderOffice";
import {ContactHistory} from "../shared/model/contactHistory.model";


@Component({
  selector: 'app-appointment-history',
  templateUrl: './appointment-history.component.html',
  styleUrls: ['./appointment-history.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AppointmentHistoryComponent implements OnInit {
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;

  appointment: Appointment;
  appointments: Appointment[];
  private _danger = new Subject<string>();
  errorMessage: string;
  private _success = new Subject<string>();
  successMessage: string;
  ServerConstants: any;
  sharedData: any;
  referralId: string = '';
  wpPersonId: string = '';
  providerId: string = '';

  wpPerson: WpPerson;
  userActionNotificationsMap: any;
  refData: any;
  appoinmentTypeStaticData: any[];
  appoinmentStatusStaticData: any[];

  activityStaticDataMap: any;
  appoinmentTypeStaticDataMap: any;
  appoinmentStatusStaticDataMap: any;
  locations: Array<any> = [];

  providerOffices: ProviderOffice[] = [];

  appointmentTypes: any;
  appointmentStatus:any;
  appointmentMethod: any;
  countyCds:any;

  appointmentTypesMap: any;
  appointmentStatusMap:any;
  appointmentMethodMap: any;
  countyMap: any;
  locationMap: any;

  appointmentTypesJson: any;
  appointmentStatusJson:any;
  appointmentMethodJson: any;
  countyJson: any;
  locationJson: any;

  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;

  /*Grid Table*/
  columnDefs: any;
  context: any;
  gridOptions: GridOptions;
  gridApi : any;
  tabToNextCell: any;
  firstTime: Boolean = true;

  // Audit Table
  auditColumnDefs: any;


  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    config: NgbTimepickerConfig,
    private dateUtil: DateUtility,
    private timeUtil: TimeUtility,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private router: Router,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility
  ) {
    this.gridOptions = <GridOptions>{};
    this.ServerConstants = serverConstantsService.getConstants();
    if(this.dataService.getSharedDataObject().get('APPTS') === undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    this.sharedData = this.dataService.getSharedDataObject();

    console.log(this.dataService.getSharedDataObject().get('APPTS').innerNavPages[0]);
    console.log(this.dataService.getSharedDataObject().get('APPTS').innerNavPages[1]);

    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.providerId = this.sharedData.get('providerId');
    this.locations = this.sharedData.get('providerOffice');

    this.wpPerson = new WpPerson();
    this.wpPerson.id = parseInt(this.wpPersonId);
    this.appointment = new Appointment();

    this.appointment.wpPerson = this.wpPerson;
    this.appointment.referralId = parseInt(this.referralId);

    this.getColumnDefinitions();
    //Audit Table
    this.getAuditColumnDefinations();
    this.appointments = [];
    this.load(this.appointment);
  }

  onGridReady(params) {
    this.gridOptions.api = params.api;
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  getColumnDefinitions() {
    this.columnDefs = [
      { headerName: 'Appointment Date & Time',
        field: 'appointmentTime',
        filter: "agDateColumnFilter",
        width: 230,
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
      },
      {
        headerName: 'Appointment Created By',
        field: 'createdBy',
        cellStyle: {'white-space': 'normal'},

      },
      {
        headerName: 'Appointment Type',
        field: "appointmentType",
        refData: this.appointmentTypesJson,
        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getAppTypeCd,
      },
      {
        headerName: 'Appointment Method',
        field: "appointmentMethodCd",
        refData: this.appointmentMethodJson,
        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getAppMethodCd,
      },
      {
        headerName: 'Appointment Location',
        field: 'appointmentLocation',
        refData: this.locationJson,
        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getLocationCd,
      },
      {
        headerName: 'Appointment Status',
        field: "appointmentStatusCd",
        refData: this.appointmentStatusJson,
        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getAppStatusCd,
      },
      {
        headerName: 'Action',
        width: 110,
        field: '',
        cellRenderer: this.getActionButton,
        suppressFilter: true,
        suppressSorting: true
     }
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;

      } else {
        return nextCell;
      }
    };

    this.context = {
      component: this,
    };
  }

  getAuditColumnDefinations() {
    this.auditColumnDefs = [
      { headerName: 'Appointment Date',
        field: 'appointmentTime',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      },
      {
        headerName: 'Appointment Type',
        field: "appointmentType",
        valueGetter: this.getAppointmentType,
        tooltip: this.getAppointmentType
      },
      {
        headerName: 'Appointment Status',
        field: "appointmentStatusCd",
        valueGetter: this.getAppointmentStatus,
        tooltip: this.getAppointmentStatus
      },
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      { headerName: 'Modified Date',
        field: 'lastModifiedDate',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      },
      {
        headerName: 'Appointment Location',
        field: 'appointmentLocation',
        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getAppointmentLocation,
        tooltip: this.getAppointmentLocation
      }
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };

    this.context = {
      component: this,
    };
  }

  getAppointmentType(params) {
    let appType;
    if(params.context.appointmentTypesMap === undefined) {
      appType = ""
    } else {
      appType = params.context.appointmentTypesMap.get(params.data.appointmentType);
    }
    return appType;
  }

  getAppointmentStatus(params) {
    let appStatus;
    if(params.context.appointmentStatusMap === undefined) {
      appStatus = ""
    } else {
      appStatus = params.context.appointmentStatusMap.get(params.data.appointmentStatusCd);
    }
    return appStatus;
  }

  getAppointmentLocation(params) {
    let locationCd;
    if(params.context.locationMap === undefined) {
      locationCd = ""
    } else {
      locationCd = params.context.locationMap.get(params.data.appointmentLocation);
    }
    return locationCd;
  }

  getActionButton(params) {
    const that = params.context.component;

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.WpAppointmentEntity');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Appointment Audit');
      that.router.navigate(['/task/appointment/auditHistory']);
    });

    auditElement.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.WpAppointmentEntity');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Appointment Audit');
        that.router.navigate(['/task/appointment/auditHistory']);
      }
      /*else if( (!event.shiftKey && event.keyCode === 9 ) && (params.rowIndex === (that.appointments.length -1 ))){
        event.preventDefault();
        setTimeout(() => that.header.nativeElement.focus(), 0);
        that.header.nativeElement.click();
      }*/
    });
    auditElement.setAttribute("tabindex", "0");
    // const divCol2 = document.createElement('div');
    // divCol2.setAttribute("class", "col-1");
    // divCol2.appendChild(auditElement);
    // divRow.appendChild(divCol1);
    // divRow.appendChild(divCol2);

    return auditElement;
  }


  getLocationCd(params){
    const that = params.context.component;

    let locationCd = that.convertCode(that.locationMap, params.data.appointmentLocation);
    if(params.data.appointmentLocation == undefined){
      locationCd = "";
    }
    return locationCd;
  }

  getAppTypeCd(params){
    const that = params.context.component;

    let appointmentType = that.convertCode(that.appointmentTypesMap, params.data.appointmentType);
    if(params.data.appointmentType == undefined){
      appointmentType = "";
    }
    return appointmentType;
  }

  getAppStatusCd(params){
    const that = params.context.component;
    let appointmentStatus = that.convertCode(that.appointmentStatusMap, params.data.appointmentStatusCd);
    if(params.data.appointmentStatusCd == undefined){
      appointmentStatus = "";
    }
    return appointmentStatus;
  }

  getAppMethodCd(params){
    const that = params.context.component;
    let appointmentsMethod = that.convertCode(that.appointmentMethodMap, params.data.appointmentMethodCd);
    if(params.data.appointmentMethodCd == undefined){
      appointmentsMethod = "";
    }
    return appointmentsMethod;
  }

  convertCode(myMap, code){
    if(myMap != undefined){
      return myMap.get(code);
    }
  }

  parseRefTableData(){
      this.appointmentTypes = this.data.getValueFromSharedDataMap("appointmentType");
      this.appointmentStatus = this.data.getValueFromSharedDataMap("appointmentStatus");
      this.appointmentMethod = this.data.getValueFromSharedDataMap("appointmentMethod");
      this.countyCds = this.data.getValueFromSharedDataMap('COUNTIES');

      this.appointmentTypesMap  = this.commonUtil.createMapFromList(this.appointmentTypes);
      this.appointmentStatusMap  = this.commonUtil.createMapFromList(this.appointmentStatus);
      this.appointmentMethodMap = this.commonUtil.createMapFromList( this.appointmentMethod );
      this.countyMap = this.commonUtil.createMapFromList(this.countyCds);

      this.appointmentTypesJson  = this.commonUtil.createNativeMapFromList(this.appointmentTypes);
      this.appointmentStatusJson = this.commonUtil.createNativeMapFromList( this.appointmentStatus );
      this.appointmentMethodJson = this.commonUtil.createNativeMapFromList( this.appointmentMethod );
      this.countyJson = this.commonUtil.createNativeMapFromList(this.countyCds);

      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));

      this.locationMap = this.commonUtil.createMapFromList(this.locations);
      this.locationJson = this.commonUtil.createNativeMapFromList(this.locations);


  }

  load(appointment){
    var time;
    this.http.post<Appointment[]>(this.ServerConstants.SERVER_API_URL + '/appointment/loadHistory' , appointment ).subscribe(
      (data: Appointment[] ) => {
        if(data.hasOwnProperty('errorCode')){
          this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
          this.appointment = new Appointment();
        }else {

          if(data != undefined && data.length > 0){
            this.appointments=data;
          }
        }
      },
      response => {
        this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
      },
      () => {
        this.parseRefTableData();
      });
  }

  focusSummary(e: KeyboardEvent) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event){
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if ( event.keyCode !== tabKeyCode) {
      return;
    }

    if ( this.appointments.length === 0) {
      return;
    }

    if ( event.shiftKey ) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }
  filter(event){
    this.firstTime = true;
  }

 /* ngOnDestroy() {
   this.dataService.removeValueFromSharedDataMap('providerOffice');
  }
*/
}



// WEBPACK FOOTER //
// ./src/app/appointment-history/appointment-history.component.ts